import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useHideMembershipsOnboardingMutation = createMutationHook(
  MembershipsCreatorApiClient.hideOnboarding,
  {
    mutationKey: ['hideMembershipsOnboarding'],
  },
)
